export default function Dialog(theme: any) {
	return {
		MuiDialogContent: {
			defaultProps: {
				dividers: true,
			},
			styleOverrides: {
				root: {
					overflowX: 'hidden',
					backgroundColor: theme.palette.grey[1000],
				},
			},
		},
		MuiDialogActions: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.grey[200],
				},
			},
		},
	};
}
